<template>
  <el-col
    :xs="24"
    :sm="24"
    :md="5"
    :lg="5"
    :xl="5"
    class="sidebar leftfloat middle"
  >
    <div class="grid-content bg-purple">
      <LoginControl class="Pclogin"></LoginControl>
      <div class="tgxz ten">
        <div class="title_all">
          <div class="left">欢迎关注与加入</div>
          <div class="clearfix"></div>
        </div>
        <div class="pd15 text-center">
          <img src="../../assets/images/ewm.png" width="100%" alt="" />
        </div>
      </div>
      <!-- 投稿指南 -->
      <div class="tgxz fifth">
        <div class="title_all">
          <div class="left">投稿指南</div>
          <span class="title_more">
            <router-link to="/NewsList?ColumnId=13"></router-link>
          </span>
          <div class="clearfix"></div>
        </div>
        <Control :params="{ ColumnId: 13, PageSize: 6 }"></Control>
      </div>
      <!-- 作者园地 -->
      <div class="tgxz fifth">
        <div class="title_all">
          <div class="left">作者园地</div>
          <span class="title_more">
            <router-link to="/NewsList?ColumnId=11"></router-link>
          </span>
          <div class="clearfix"></div>
        </div>
        <Control :params="{ ColumnId: 11, PageSize: 6 }"></Control>
      </div>
      <div class="tgxz fifth">
        <div class="title_all">
          <div class="left">文章检索</div>
          <div class="clearfix"></div>
        </div>
        <div class="pd15">
          <Search />
        </div>
      </div>
      <div class="tgxz fifth">
        <div class="title_all">
          <div class="left">访问统计</div>
          <div class="clearfix"></div>
        </div>
        <ul class="list five notice">
          <li>当前在线人数：{{ OnlineNumber }}</li>
          <li>总访问量统计：{{ Count }}</li>
          <li>今日访问量：{{ CurrentDay }}</li>
        </ul>
      </div>
    </div>
  </el-col>
</template>

<script>
import Control from "./page/Control";
import Ranking from "./page/Ranking";
import LoginControl from "../LoginControl";
import vueSeamlessScroll from "vue-seamless-scroll";
  import Search from '../../components/Home/Search.vue';
export default {
  name: "Sidebar",
  data() {
    return {
      activeName: "first",
      type: 1,
      activeNamea: "firsta",
      activeNameb: "firstb",
      slqk: "",
      data: {},
      Volume: "",
      newYears: "",
      newMonth: "",
      SetItem: {},
      ISSN: "",
      CN: "",
      imgUrl: "",
      YearIssue_NoTtitle: "",
      getDisnum: [],
      Info: "",
      listData: [],
      OnlineNumber: 0,
      Count: 0,
      CurrentDay: 0,
    };
  },
  created() {
    this.getDisnumList(); //获取过刊目录
    this.getProfile();
    this.getnewslist();
    this.getAllSum();
  },
  props: ["isgzh"],
  components: { Control, LoginControl, Ranking, vueSeamlessScroll,Search },
  mounted() {
    if (this.$route.path == "/FixedBody") {
      this.activeName = "first";
    } else if (this.$route.path === "/Authorgarden") {
      this.activeName = "two";
    }
    if (sessionStorage.getItem("slqk")) {
      this.slqk = JSON.parse(sessionStorage.getItem("slqk"));
    } else {
      let params = [80, 8, 9, 1400];
      this.$store.dispatch("_getHeader", params).then((res) => {
        res.data.Data.map((item) => {
          if (item.ItemId == 1400) {
            this.slqk = item.Body;
            sessionStorage.setItem("slqk", JSON.stringify(item.Body));
          }
        });
      });
    }
    if (sessionStorage.getItem("newYears")) {
      this.data = JSON.parse(sessionStorage.getItem("newYears"));
      this.Volume = this.data.Volume;
      this.newYears = this.data.newYears;
      this.imgUrl = this.data.CoverGUID + this.data.CoverSuffix;
      this.YearIssue_NoTtitle = this.data.YearIssue_NoTtitle;
    } else {
      this.$store.dispatch("_getYear", { Id: -1 }).then((res) => {
        if (res.data.Data) {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
          let data = {
            newYears: res.data.Data.Publish_Date,
            Volume: res.data.Data.Volume,
            CoverGUID: res.data.Data.CoverGUID,
            CoverSuffix: res.data.Data.CoverSuffix,
            YearIssue_NoTtitle: res.data.Data.YearIssue_NoTtitle,
          };
          this.Volume = res.data.Data.Volume;
          this.newYears = res.data.Data.Publish_Date;
          this.imgUrl = res.data.Data.CoverGUID + res.data.Data.CoverSuffix;
          this.YearIssue_NoTtitle = res.data.Data.YearIssue_NoTtitle;
          sessionStorage.setItem("newYears", JSON.stringify(data));
        }
      });
    }
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 5000) {
          this.ISSN = item.Item_Value;
        }
        if (item.SetItemID == 5010) {
          this.CN = item.Item_Value;
        }
      });
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        4554,
      ];
      this.$store.dispatch("_getSet", params).then((res) => {
        this.SetItem = res.data.Data;
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
        this.SetItem.map((item) => {
          if (item.SetItemID == 5000) {
            this.ISSN = item.Item_Value;
          }
          if (item.SetItemID == 5010) {
            this.CN = item.Item_Value;
          }
        });
      });
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.4, // 数值越大速度滚动越快
      };
    },
  },
  methods: {
    getAllSum() {
      this.$store
        .dispatch("_getAllSum", { isen: false })
        .then((res) => {
          this.Count = res.data.Data.Count;
          this.CurrentDay = res.data.Data.CurrentDay;
          this.CurrentLast = res.data.Data.CurrentLast;
          this.OnlineNumber = res.data.Data.OnlineNumber;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getnewslist() {
      let data = { ColumnId: 11 };
      this.$store
        .dispatch("_getActor", data)
        .then((res) => {
          this.listData = res.data.Data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClick(tab, event) {},
    handleClicka(tab, event) {},
    onick() {
      if (this.activeName == "first") {
        this.$router.push({
          path: "/NewsList?ColumnId=5",
        });
      } else if (this.activeName == "two") {
        this.$router.push({
          path: "/Authorgarden",
        });
      }
    },
    onicka() {
      if (this.activeNamea == "firsta") {
        this.$router.push({
          path: "/DownloadlistViewlist?Key=ReadRank",
        });
      } else if (this.activeNamea == "twoa") {
        this.$router.push({
          path: "/DownloadlistViewlist?Key=ViewRank",
        });
      }
    },
    //获取过刊目录列表
    getDisnumList() {
      this.$store.dispatch("_getgok").then((res) => {
        if (res.data.IsSuccess) {
          this.getDisnum = res.data.Data.Year;
        }
      });
    },
    tomouth(id, type) {
      this.$router.push({
        path: "/OAList?IssueId=" + id,
      });
    },
    tomouthgzh(id, type) {
      this.$router.push({
        path: "/gzhOAList?IssueId=" + id,
      });
    },
    getProfile() {
      let data = [12];
      this.$store.dispatch("_getHeader", data).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.Info = res.data.Data[0].Body;
          }
        }
      });
    },
  },
};
</script>

<style>
.qktext p {
  line-height: 24px;
}
.qkjjtext img {
  height: 210px;
  display: inline-block;
  background: #dedede;
}
.cover_info {
  line-height: 27.5px;
  font-size: 14px;
  color: #000;
}
.cover_info .title {
  width: 70px;
}
.cover_info_text {
  width: 65%;
}
@media (max-width: 1200px) {
  .cover_info {
    line-height: 25px;
  }
  .cover_info_text {
    width: 60%;
  }
}
@media (max-width: 420px) {
  .cover_info {
    line-height: 26px;
  }
}
.IssueNum {
  width: 100%;
  float: left;
  line-height: 30px;
}
.year {
  font-weight: bold;
  color: #0278ce;
  background: url("../../assets/images/arrow.gif") no-repeat left center;
  padding-left: 12px;
  width: 40px;
}
.yearList {
  width: 80%;
}
.IssueNum ul li {
  float: left;
  margin: 0 10px;
  background: none !important;
}
.seamless-warp {
  width: 100%;
  height: 225px;
  overflow: hidden;
}
</style>
